import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';

const PRODUCT_KEY_NAMES = [
    'specification',
    'products',
    'additionals',
    'specificationAmount',
    'productsAmount',
    'additionalsAmount',
    'specificationAmountVat',
    'productsAmountVat',
    'additionalsAmountVat',
    'specificationAmountText',
    'productsAmountText',
    'additionalsAmountText',
    
] as const;

interface KeysTabProps {
    onKeySelect?: (key: string) => void;
}

const ProductsServicesKeysTab = ({ onKeySelect }: KeysTabProps) => {
    const { t } = useTranslation('TemplateValueKeys');

    const rows = useMemo<TemplateKeyRow[]>(
        () =>
            PRODUCT_KEY_NAMES.map((name) => ({
                key: wrapTemplateKey(name),
                value: t(`directory.products.${name}`),
            })),
        [t],
    );

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default ProductsServicesKeysTab;
